import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  Stack,
  Container,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import {
  CalendarMonth as CalendarIcon,
  Hotel as HotelIcon,
  AttachMoney as MoneyIcon,
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material';
import { eachDayOfInterval, format, parseISO } from 'date-fns';
import {
  formatDate,
  formatDateText,
} from './CommonFunctions';
import Header from "./Header.js";

const FreeDaysDeposit = (props) => {
  const [startDate, setStartDate] = useState(formatDate(new Date(), -7));
  const [endDate, setEndDate] = useState(formatDate(new Date()));
  const url = process.env.REACT_APP_SERVER_URL;
  const [freeDaysData, setFreeDaysData] = useState([]);
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    getFreeRoomsByDate();
  }, []);

  const getFreeRoomsByDate = async () => {
    try {
      await axios.post(`${url}/vacancyCheckByDateRange`, {
        startDate,
        endDate
      }).then((responseForRooms) => {
        setFreeDaysData(responseForRooms.data);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const preProcess = (data, startDate, endDate, rooms) => {
    let myDict = {};
    console.log("start Date : " + startDate + " end date : " + endDate);
    const interval = {
      start: parseISO(startDate),
      end: parseISO(endDate)
    };
    const dates = eachDayOfInterval(interval).map(date => format(date, 'yyyy-MM-dd'));

    const result = {};
    dates.forEach(date => {
      result[date] = [];
    });

    Object.entries(data).forEach(([roomId, tenancies]) => {
      tenancies.forEach(tenancy => {
        const checkInDate = format(parseISO(tenancy.checkin), 'yyyy-MM-dd');
        let checkoutDate = null;
        if (tenancy.actualCheckoutDate === null) {

        } else {
          checkoutDate = format(parseISO(tenancy.actualCheckoutDate), 'yyyy-MM-dd');
        }

        dates.forEach(date => {
          if (checkoutDate === null) {
            if (date >= checkInDate) {
              result[date].push(parseInt(roomId));
            }
          } else {
            if (date >= checkInDate && date < checkoutDate) {
              result[date].push(parseInt(roomId));
            }
          }
        });
      });
    });

    const resultArray = [];
    for (let key in result) {
      const occupiedRooms = result[key];
      console.log(occupiedRooms);
      const vacantRooms = rooms.filter(row => !occupiedRooms.includes(row.id));
      let lostRent = 0;
      vacantRooms.map((row) => {
        lostRent += row.dailyRate;
      });
      resultArray.push({
        date: key,
        occupiedRooms: occupiedRooms,
        vacantRooms: vacantRooms,
        lostRent: lostRent
      });
    }
    console.log(resultArray);
    return resultArray;
  };

  const totalDays = freeDaysData.length;
  const fullyRentedDays = freeDaysData.filter(row => row.vacantRooms.length === 0).length;
  const totalLostRent = freeDaysData.reduce((sum, row) => sum + row.lostRent, 0);
  const avgVacantRooms = totalDays > 0
    ? (freeDaysData.reduce((sum, row) => sum + row.vacantRooms.length, 0) / totalDays).toFixed(1)
    : 0;

  const columns = [
    {
      field: 'date',
      headerName: 'Date',
      width: 220,
      sortable: true,
      renderCell: (params) => formatDateText(params.row.date)
    },
    {
      field: 'vacantRooms',
      headerName: 'Rooms that are vacant',
      width: 290,
      sortable: true,
      renderCell: (params) => (
        <div>
          {params.row.vacantRooms.map(room => room.id).join(', ')}
        </div>
      )
    },
    {
      field: 'vacantRoomsCount',
      headerName: 'No.of Rooms',
      width: 180,
      renderCell: (params) => (
        params.row.vacantRooms.length == 0 
          ? <b style={{ color: "green" }}>Fully rented</b> 
          : params.row.vacantRooms.length
      )
    },
    {
      field: 'lostRent',
      headerName: 'Predicted Lost Rent',
      width: 180,
      renderCell: (params) => "$" + params.row.lostRent
    },
  ];

  const rows = freeDaysData.map((row, index) => ({
    id: index,
    ...row
  }));

  return (
    <>
      <Header />
      <Container maxWidth="xl" sx={{ mt: 3, mb: 2 }}>
 
          <Box sx={{ display: 'flex', justifyContent: 'space-between', 
          alignItems: 'center', mb: 3,
            pb: 2,borderBottom: 1,borderColor: "divider", }}>
            <Typography variant="h6" fontWeight="600">
              Vacancy Report
            </Typography>
            <Stack direction="row" spacing={2} alignItems="center">
              <TextField
                label="Start Date"
                type="date"
                value={startDate}
                size="small"
                onChange={(e) => setStartDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ minWidth: 180 }}
              />
              <TextField
                label="End Date"
                type="date"
                size="small"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ minWidth: 180 }}
              />
              <Button
                variant="contained"
                onClick={(e) => getFreeRoomsByDate()}
                sx={{ textTransform: 'none', fontWeight: 600 }}
              >
                Search
              </Button>
            </Stack>
          </Box>

          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6} md={3}>
              <Card elevation={2}>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box sx={{ bgcolor: 'primary.main', color: 'white', p: 1.5, borderRadius: 2 }}>
                      <CalendarIcon />
                    </Box>
                    <Box>
                      <Typography variant="body" color="text.secondary">Total Days</Typography>
                      <Typography variant="h6" fontWeight="600">{totalDays}</Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card elevation={2}>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box sx={{ bgcolor: 'success.main', color: 'white', p: 1.5, borderRadius: 2 }}>
                      <CheckCircleIcon />
                    </Box>
                    <Box>
                      <Typography variant="body" color="text.secondary">Fully Rented Days</Typography>
                      <Typography variant="h6" fontWeight="600">{fullyRentedDays}</Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card elevation={2}>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box sx={{ bgcolor: 'warning.main', color: 'white', p: 1.5, borderRadius: 2 }}>
                      <HotelIcon />
                    </Box>
                    <Box>
                      <Typography variant="body" color="text.secondary">Avg Vacant Rooms</Typography>
                      <Typography variant="h6" fontWeight="600">{avgVacantRooms}</Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card elevation={2}>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box sx={{ bgcolor: 'error.main', color: 'white', p: 1.5, borderRadius: 2 }}>
                      <MoneyIcon />
                    </Box>
                    <Box>
                      <Typography variant="body" color="text.secondary">Total Lost Rent</Typography>
                      <Typography variant="h6" fontWeight="600">${totalLostRent.toLocaleString()}</Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Paper elevation={2} sx={{ borderRadius: 2 }}>
          <Box sx={{ height: 500, width: '100%' }}>
            <DataGrid
              rows={rows}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[10, 25, 50]}
              disableSelectionOnClick
              sx={{
                border: "none",
                "& .MuiDataGrid-cell": {
                  borderBottom: 1,
                  borderColor: "divider",
                },
                "& .MuiDataGrid-columnHeaders": {
                  bgcolor: "grey.50",
                  borderBottom: 2,
                  borderColor: "divider",
                },
              }}
            />
          </Box>
          </Paper>
      </Container>
    </>
  );
};

export default FreeDaysDeposit;